import { Equipment, DataArray, IDataArray } from './../../shared/index';

export class PoweredBy implements IDataArray {
    public Id: number;
    public Name = '';
    public AttributeId: number;
    public Status: number;
    public Is_Changed: boolean;
    public Equipment: DataArray<Equipment> = new DataArray<Equipment>(1);

    public UseCount = 0;

    public GetById(): number {
        return this.Id;
    }
}
